/* eslint-disable @typescript-eslint/no-explicit-any */
import { Filters } from 'constants/filters';
import { Routes } from 'constants/routes';

export type TAvailableRoutes =
    | Routes.ACTIVE_CONVERSATIONS
    | Routes.ARCHIVE
    | Routes.CONTACTED
    | Routes.LISTED
    | Routes.RECOMMENDED
    | Routes.SEARCH
    | Routes.SOLD;

export const availableRoutes: TAvailableRoutes[] = [
    Routes.ACTIVE_CONVERSATIONS,
    Routes.ARCHIVE,
    Routes.CONTACTED,
    Routes.LISTED,
    Routes.RECOMMENDED,
    Routes.SEARCH,
    Routes.SOLD,
];

export type TFilterState = {
    values: Array<string | number>;
};

export type TState = Record<TAvailableRoutes, Record<Filters, TFilterState>>;

export const filtersInitialState: Record<Filters, any> = {
    [Filters.CITIES]: [],
    [Filters.STATES]: [],
    [Filters.EDM_MIN]: undefined,
    [Filters.EDM_MAX]: undefined,
    [Filters.PRICE_MIN]: undefined,
    [Filters.PRICE_MAX]: undefined,
    [Filters.FROM_DATE]: undefined,
    [Filters.TO_DATE]: undefined,
    [Filters.LEAD_TYPES]: [],
};

export const state: TState = {
    [Routes.ACTIVE_CONVERSATIONS]: filtersInitialState,
    [Routes.ARCHIVE]: filtersInitialState,
    [Routes.CONTACTED]: filtersInitialState,
    [Routes.LISTED]: filtersInitialState,
    [Routes.RECOMMENDED]: filtersInitialState,
    [Routes.SEARCH]: filtersInitialState,
    [Routes.SOLD]: filtersInitialState,
};
